import { disconnectSettingsInstagramApi as generatedDisconnectSettingsInstagramApi } from '../generated/settingsInstagram/disconnectSettingsInstagram';

const disconnectSettingsInstagramApi = generatedDisconnectSettingsInstagramApi.enhanceEndpoints({
  endpoints: {
    disconnectSettingsInstagram: {
      invalidatesTags: ['SettingsCommunicationChannels'],
    },
  },
});

export const { useDisconnectSettingsInstagramMutation } = disconnectSettingsInstagramApi;
